import { useFragmentContext } from '@jsmdg/react-fragment-scripts/fragment';
import { type ProductDetailContext } from '../../types/types';

const Reviews = (): JSX.Element => {
    const { product } = useFragmentContext<ProductDetailContext>();

    return (
        <div
            className="yotpo yotpo-main-widget"
            data-product-id={product.productId}
            data-price={product.price.gross.amount}
            data-currency={product.price.gross.currencyCode}
            data-name={product.title}
            data-url={product.url}
            data-image-url={product.images[0].absoluteUrl}
            data-testid="review-test-id"
        />
    );
};

export { Reviews };
